// extracted by mini-css-extract-plugin
export var button = "_of-0";